import React from 'react';
import EllipsisWithTooltip from 'react-ellipsis-with-tooltip';
import cellFormatter from './cellFormatter';

export default value =>
  cellFormatter(<EllipsisWithTooltip>{value || ''}</EllipsisWithTooltip>);



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/common/table/formatters/ellipsisCellFormatter.js